var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _ellipse, _path36, _path37, _path38, _ellipse2, _path39, _ellipse3, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 406.58 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:#305290;}.cls-12{fill:#489158;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 118.99,
    y1: 103.91,
    x2: 118.99,
    y2: 35.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#478f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#428165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#345c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 22.16,
    y1: 73.45,
    x2: 22.16,
    y2: 226.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#478f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3d7372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#335b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#305290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 59.96,
    y1: 35.71,
    x2: -35.33,
    y2: 35.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 90,
    y1: 94.51,
    x2: 40.76,
    y2: 94.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 81.66,
    y1: 224.79,
    x2: 81.66,
    y2: 61.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 151.62,
    y1: 36.45,
    x2: 50.14,
    y2: 36.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 70.87,
    x2: 110.48,
    y2: 70.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#478f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#509a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#60ae4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#69b947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6cbd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6fbe45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#79c145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8bc745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a3ce44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#c1d844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0dd44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 110.52,
    y1: 77.16,
    x2: 142.09,
    y2: 77.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cbd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#69ba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#61b04b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#549f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#478f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 107.36,
    y1: 20.38,
    x2: 123.79,
    y2: 20.38,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 121.29,
    y1: 24.72,
    x2: 104.83,
    y2: 24.72,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126,45.67h-15.5l-3.88,4.44h14.24a54.7,54.7,0,0,1,4.88,22.76c0,11.25-4.94,22.46-13.12,30.73l4.41.31c8.91-9,14.28-21.21,14.28-33.45A59.73,59.73,0,0,0,126,45.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.08,75.92l-4.24-2.15a60.18,60.18,0,0,0,21.08,42.56,21.21,21.21,0,0,0,1.56-2.16A55.27,55.27,0,0,1,15.08,75.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.2,15.11c-1.22.54-2.43,1.11-3.62,1.73-11.43,5.93-20.7,14.82-26.12,25C16.78,45,16,48.06,16.51,49.74c.71,2.44,2.5,4.49,5,6.57a8.62,8.62,0,0,1-1.18-2.47c-.44-1.54.24-4.31,1.79-7.22,5-9.38,13.5-17.55,24-23,1.09-.57,2.21-1.09,3.33-1.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90,115.75l-2.2-1.27a57.36,57.36,0,0,1-12.72-1.4c-10.25-2.24-19.57-6.83-25.4-12.44.51-8.33-1.44-16.71-5.32-22.64a42.1,42.1,0,0,0-3.6-4.72c.67.88,1.33,1.79,2,2.76,4.22,6.45,6.34,15.57,5.79,24.64,6.34,6.11,16.49,11.11,27.65,13.55a64.38,64.38,0,0,0,10.72,1.45h0C87.94,115.73,89,115.76,90,115.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.57,122.31c5.06-6.75,7.76-20.69,1.72-35.36A21.73,21.73,0,0,0,82.92,74.21a25.82,25.82,0,0,0-19.35,1.27l.09,1.94a23.71,23.71,0,0,1,17.63-1.1A20,20,0,0,1,93.57,88c5.55,13.48,3.07,26.29-1.58,32.48-4.27,5.69-11.29,8.34-20.91,7.92.24.94.47,1.78.67,2.5C82.25,131.4,89.91,128.5,94.57,122.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.14,25.06c5.61,6.23,6.46,15.21,5.38,21.53A39.27,39.27,0,0,1,87.1,57.41,41.15,41.15,0,0,0,93,41.84c1.17-6.88.24-16.65-5.86-23.44-4.36-4.84-10.63-7.4-18.68-7.62a275,275,0,0,0-5.09,51.35A252.11,252.11,0,0,1,68,18.05C75.37,18.26,81.14,20.61,85.14,25.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.24,67.27a50.14,50.14,0,0,0,10.34-23.63c2.06-12.12-1.1-24.25-8.47-32.43C90,5.57,80.48-.93,63.68.11L59.6.37l-.85,4a291.23,291.23,0,0,0-4.59,90.46,60.82,60.82,0,0,0,11.77,7.08c-1.07-7.71-2-16.6-2.36-26.42a25.82,25.82,0,0,1,19.35-1.27A21.73,21.73,0,0,1,96.29,87c6,14.67,3.34,28.61-1.72,35.36-4.66,6.19-12.32,9.09-22.82,8.61-.49-1.74-1.12-4.15-1.82-7.15l.16,0c8.94.37,15.47-2.11,19.45-7.41.16-.21.31-.43.46-.65a63,63,0,0,1-13.84-1.52c-11.16-2.44-21.31-7.44-27.65-13.55.55-9.07-1.57-18.19-5.79-24.64C37.85,68.6,31.51,63.9,26.42,60.13c-4.91-3.64-8.79-6.51-9.91-10.39-.48-1.68.27-4.7,1.95-7.87,5.42-10.21,14.69-19.1,26.12-25,1.19-.62,2.4-1.19,3.62-1.73.78-4.66,1.57-8.77,2.34-12.39A71.91,71.91,0,0,0,39.62,7.29C26.28,14.21,15.38,24.7,9,36.83,6.78,40.92,4.53,47,6.17,52.71,8.29,60.1,14.25,64.51,20,68.78c4.86,3.6,9.88,7.32,13.7,13.15,3.1,4.75,4.63,12.09,4,19.17a27.82,27.82,0,0,1-5.77,15.23A60.18,60.18,0,0,1,10.84,73.77l-2.15-2A46.37,46.37,0,0,1,.6,62,67,67,0,0,0,0,70.81a71,71,0,0,0,29.12,57l3.32,2.42,3.22-2.56a33.52,33.52,0,0,0,10.45-15,66.53,66.53,0,0,0,11.83,6.81,164.4,164.4,0,0,0,4.61,18.26l1.1,3.26,3.42.37a62.72,62.72,0,0,0,6.78.38c16,0,24.71-6.82,29.32-13,9.81-13.06,8.61-32.47,3.07-45.92A32.93,32.93,0,0,0,93.24,67.27ZM82.67,63a37,37,0,0,0-19.34,1,275.33,275.33,0,0,1,5.1-53.22c8,.22,14.32,2.78,18.68,7.62,6.1,6.79,7,16.56,5.86,23.44A39,39,0,0,1,82.67,63Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M134.17,37.82l-1.51-2.91H111.35A51.77,51.77,0,0,1,110.64,45l-.12.63H126a59.73,59.73,0,0,1,5.31,24.79c0,12.24-5.37,24.44-14.28,33.45,0,.77,0,1.53,0,2.29a54.46,54.46,0,0,1-2,13.2c16.5-10.94,27-29.86,27-48.94A71.29,71.29,0,0,0,134.17,37.82Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 115.58,
    cy: 20.38,
    r: 8.22
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M107.36,20.38a8.08,8.08,0,0,1,.83-3.57h0l-2.61,5.12h0a7.46,7.46,0,0,0,12.46,8h0l3.25-3.66h0a8.22,8.22,0,0,1-13.93-5.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M10.84,73.77l-2.15-2A46.37,46.37,0,0,1,.6,62l5.07,3.11a43,43,0,0,0,7.43,9l2,1.89Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.4,22q.93-5.61,2.15-11.38l-1-7.93C49.77,6.34,49,10.45,48.2,15.11Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M115.07,119.4a54.46,54.46,0,0,0,2-13.2c0-.76,0-1.52,0-2.29l-4.41-.31c0,.71,0,1.41,0,2.1a49.79,49.79,0,0,1-1.8,12.13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M106.64,50.11c0-.19.08-.38.11-.58a47.27,47.27,0,0,0,.65-9.31l3.95-5.31A51.77,51.77,0,0,1,110.64,45l-.12.63Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.91,42.41a26.57,26.57,0,0,1-4.34-.36,27.67,27.67,0,0,1-4.08-1,12.84,12.84,0,0,1-3.15-1.48l.63-5.72A21.17,21.17,0,0,0,179,36a20.45,20.45,0,0,0,5.57.83,8.35,8.35,0,0,0,4.8-1.2,3.79,3.79,0,0,0,1.73-3.31,3.66,3.66,0,0,0-.58-2.09,5.09,5.09,0,0,0-2.08-1.6,29,29,0,0,0-4.19-1.53,26,26,0,0,1-6-2.53,8.7,8.7,0,0,1-3.32-3.31,9.58,9.58,0,0,1-1-4.53,9.28,9.28,0,0,1,1.51-5.31,9.75,9.75,0,0,1,4.26-3.47,15.92,15.92,0,0,1,6.49-1.22,22.82,22.82,0,0,1,5.52.7,17.39,17.39,0,0,1,4.7,1.87l-.94,5.54A16.52,16.52,0,0,0,191.11,13a17.41,17.41,0,0,0-4.71-.68,7.34,7.34,0,0,0-4.28,1.08,3.53,3.53,0,0,0-1.53,3.06,3.56,3.56,0,0,0,.52,2A4.27,4.27,0,0,0,183,19.9a28.47,28.47,0,0,0,3.68,1.42,30.83,30.83,0,0,1,6.57,2.73,9.79,9.79,0,0,1,3.61,3.37A8.8,8.8,0,0,1,197.94,32a9.27,9.27,0,0,1-3.47,7.68Q191,42.4,184.91,42.41Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.44,42.41q-4.11,0-6.13-2.19t-2-6.69V23.84h-4.46V18.75h4.46V12.53h6.22v6.22h7.16v5.09H210.5v8.52a5.76,5.76,0,0,0,.83,3.49,3.31,3.31,0,0,0,2.77,1.06,7.9,7.9,0,0,0,2.05-.27,12.71,12.71,0,0,0,2-.72l.67,5.13a9.49,9.49,0,0,1-2.83,1A18.38,18.38,0,0,1,212.44,42.41Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.12,41.68V18.75h6l0,4.55a7.68,7.68,0,0,1,2.46-3.67,6.06,6.06,0,0,1,3.85-1.28,8.27,8.27,0,0,1,1.47.13,4.56,4.56,0,0,1,1.19.36l-.54,5.9a10.05,10.05,0,0,0-1.4-.4,6.85,6.85,0,0,0-1.48-.18,4.71,4.71,0,0,0-4,1.82,8.52,8.52,0,0,0-1.4,5.25V41.68Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250.84,42.41a9.65,9.65,0,0,1-5.43-1.56,10.72,10.72,0,0,1-3.72-4.3,14,14,0,0,1-1.35-6.26,13.29,13.29,0,0,1,1.44-6.24,11.57,11.57,0,0,1,3.9-4.4A9.82,9.82,0,0,1,251.2,18a8.69,8.69,0,0,1,4.35,1.11,7.86,7.86,0,0,1,3.08,3.13l.09-3.52h5.95V41.68h-5.95l-.09-3.51Q256.25,42.4,250.84,42.41Zm1.85-5.59A5.7,5.7,0,0,0,257.06,35a6.69,6.69,0,0,0,1.71-4.73,6.74,6.74,0,0,0-1.71-4.77,6.09,6.09,0,0,0-8.74,0,6.74,6.74,0,0,0-1.71,4.77A6.69,6.69,0,0,0,248.32,35,5.69,5.69,0,0,0,252.69,36.82Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M280.75,42.41c-2.73,0-4.78-.73-6.13-2.19s-2-3.69-2-6.69V23.84h-4.46V18.75h4.46V12.53h6.21v6.22H286v5.09h-7.17v8.52a5.68,5.68,0,0,0,.84,3.49,3.3,3.3,0,0,0,2.77,1.06,8,8,0,0,0,2.05-.27,13,13,0,0,0,2-.72l.68,5.13a9.55,9.55,0,0,1-2.84,1A18.31,18.31,0,0,1,280.75,42.41Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M302.83,42.41a16.07,16.07,0,0,1-7.14-1.47,10.42,10.42,0,0,1-4.59-4.21,12.65,12.65,0,0,1-1.6-6.49A13.15,13.15,0,0,1,291,23.89a10.8,10.8,0,0,1,4.15-4.3A11.78,11.78,0,0,1,301.21,18a11.44,11.44,0,0,1,5.77,1.4,9.52,9.52,0,0,1,3.76,4,13.06,13.06,0,0,1,1.33,6,21.24,21.24,0,0,1-.14,2.34H295.58q.94,5.73,7.93,5.72a18.87,18.87,0,0,0,3.92-.42,16.5,16.5,0,0,0,3.65-1.24l.63,4.68a16.43,16.43,0,0,1-4.1,1.4A23.16,23.16,0,0,1,302.83,42.41ZM301,22.58a5,5,0,0,0-3.65,1.4,6.66,6.66,0,0,0-1.8,4h10.63a4.16,4.16,0,0,0-.09-.9,5.32,5.32,0,0,0-1.64-3.34A5,5,0,0,0,301,22.58Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M327.53,53.13a21.58,21.58,0,0,1-3.38-.27,25.56,25.56,0,0,1-3.16-.7,9.47,9.47,0,0,1-2.29-1l.67-5.27a13.59,13.59,0,0,0,3.51,1.4,15.82,15.82,0,0,0,4,.54q7.53,0,7.52-7.48V38a8.35,8.35,0,0,1-3.19,3.11,9.4,9.4,0,0,1-4.56,1.08,9.9,9.9,0,0,1-5.45-1.53,10.43,10.43,0,0,1-3.74-4.26,13.9,13.9,0,0,1-1.35-6.24A13.09,13.09,0,0,1,317.52,24a11.38,11.38,0,0,1,3.92-4.35A10,10,0,0,1,327,18a8.68,8.68,0,0,1,4.29,1.08,8.12,8.12,0,0,1,3.1,3.11l.09-3.47h6V40.06q0,6.45-3.27,9.76T327.53,53.13Zm.9-16.4a5.67,5.67,0,0,0,4.37-1.87,6.77,6.77,0,0,0,1.71-4.75,6.75,6.75,0,0,0-1.71-4.78,6.09,6.09,0,0,0-8.74,0,6.71,6.71,0,0,0-1.72,4.78,6.73,6.73,0,0,0,1.72,4.75A5.64,5.64,0,0,0,328.43,36.73Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M370.21,42.27a14.45,14.45,0,0,1-6.67-1.46,10.52,10.52,0,0,1-4.39-4.17,12.41,12.41,0,0,1-1.56-6.31A12.54,12.54,0,0,1,359.17,24a11.09,11.09,0,0,1,4.42-4.3,13.41,13.41,0,0,1,6.57-1.56,17.67,17.67,0,0,1,4,.47,12.57,12.57,0,0,1,3.4,1.29l-.76,5.22a14.67,14.67,0,0,0-6-1.39,7.1,7.1,0,0,0-5,1.73,6.16,6.16,0,0,0-1.87,4.76A6.19,6.19,0,0,0,365.75,35a7.32,7.32,0,0,0,5.18,1.76,16.51,16.51,0,0,0,6.26-1.4l.63,5.14a13.86,13.86,0,0,1-3.53,1.33A18,18,0,0,1,370.21,42.27Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.91,88.7V54.46h12.75q5.42,0,8.32,2.27a7.75,7.75,0,0,1,2.9,6.47,7.91,7.91,0,0,1-1.24,4.37,7.44,7.44,0,0,1-3.44,2.88,8.16,8.16,0,0,1,4.7,3,8.5,8.5,0,0,1,1.74,5.39,9,9,0,0,1-3.13,7.34q-3.13,2.57-9,2.57ZM187,59.41h-5.9v9.33h5.77q5.63,0,5.63-4.91a3.94,3.94,0,0,0-1.42-3.29A6.46,6.46,0,0,0,187,59.41Zm.86,14.1h-6.76V83.74h7.12a6.2,6.2,0,0,0,4.28-1.33A4.83,4.83,0,0,0,194,78.6C194,75.21,192,73.51,187.89,73.51Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25,89.42A7.24,7.24,0,0,1,207.39,87c-1.35-1.61-2-3.91-2-6.92V65.76h6.27V78.7a6.43,6.43,0,0,0,1,4,3.78,3.78,0,0,0,3.13,1.22,4.14,4.14,0,0,0,3.47-1.54,6.57,6.57,0,0,0,1.22-4.23V65.76h6.26V88.7h-6.08l-.09-3.29a6.57,6.57,0,0,1-2.79,3A9.05,9.05,0,0,1,213.25,89.42Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M245.19,88.7V54.11h6.22V88.7Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.88,89.42a9.63,9.63,0,0,1-5.43-1.56,10.58,10.58,0,0,1-3.72-4.3,14,14,0,0,1-1.35-6.26,13.34,13.34,0,0,1,1.44-6.24,11.46,11.46,0,0,1,3.9-4.39A9.75,9.75,0,0,1,267.24,65a8.79,8.79,0,0,1,4.14,1,8,8,0,0,1,3.07,2.89V54.11h6.26V88.7h-5.95l-.09-3.47a8.37,8.37,0,0,1-3.2,3.11A9.43,9.43,0,0,1,266.88,89.42Zm1.84-5.59A5.69,5.69,0,0,0,273.1,82a7.45,7.45,0,0,0,0-9.5,6.1,6.1,0,0,0-8.75,0,7.45,7.45,0,0,0,0,9.5A5.68,5.68,0,0,0,268.72,83.83Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M299.27,88.7V65.76h6l.09,3.34a6.54,6.54,0,0,1,2.77-3,8.65,8.65,0,0,1,4.3-1.06,7.45,7.45,0,0,1,6.06,2.53q2.1,2.52,2.1,7.21V88.7h-6.22V76c0-3.58-1.38-5.36-4.15-5.36a4.33,4.33,0,0,0-3.51,1.5,6.48,6.48,0,0,0-1.26,4.26V88.7Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M336.41,99.26A21.68,21.68,0,0,1,333,99a23.7,23.7,0,0,1-3.15-.7,9.17,9.17,0,0,1-2.3-1l.68-5.27a13.59,13.59,0,0,0,3.51,1.4,15.76,15.76,0,0,0,4,.54q7.51,0,7.52-7.48V85a8.37,8.37,0,0,1-3.2,3.11,9.36,9.36,0,0,1-4.55,1.08,9.88,9.88,0,0,1-5.45-1.53,10.43,10.43,0,0,1-3.74-4.26A13.84,13.84,0,0,1,325,77.16,13.09,13.09,0,0,1,326.41,71a11.38,11.38,0,0,1,3.92-4.35,10,10,0,0,1,5.54-1.6,8.54,8.54,0,0,1,4.28,1.09,8.12,8.12,0,0,1,3.11,3.1l.09-3.47h5.95V86.2q0,6.43-3.27,9.75T336.41,99.26Zm.9-15.52a5.64,5.64,0,0,0,4.37-1.87,7.46,7.46,0,0,0,0-9.53,6.11,6.11,0,0,0-8.74,0,7.49,7.49,0,0,0,0,9.53A5.65,5.65,0,0,0,337.31,83.74Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.91,133.23V99h6.9v34.24Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M188.68,133.23V110.3h6l.09,3.33a6.47,6.47,0,0,1,2.77-3,8.52,8.52,0,0,1,4.3-1.06,7.44,7.44,0,0,1,6.06,2.52c1.39,1.68,2.09,4.09,2.09,7.21v13.92h-6.21V120.48c0-3.57-1.39-5.36-4.15-5.36a4.31,4.31,0,0,0-3.51,1.51,6.44,6.44,0,0,0-1.26,4.26v12.34Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M215.76,133.23V110.3h6l.09,3.33a6.53,6.53,0,0,1,2.77-3,8.55,8.55,0,0,1,4.31-1.06A7.44,7.44,0,0,1,235,112.1c1.39,1.68,2.09,4.09,2.09,7.21v13.92H230.9V120.48q0-5.36-4.14-5.36a4.33,4.33,0,0,0-3.52,1.51,6.44,6.44,0,0,0-1.26,4.26v12.34Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M253.71,134a12.6,12.6,0,0,1-6.35-1.58A11.58,11.58,0,0,1,243,128a12.23,12.23,0,0,1-1.6-6.24,12.09,12.09,0,0,1,1.62-6.24,11.74,11.74,0,0,1,4.42-4.37,12.4,12.4,0,0,1,6.3-1.6,12.55,12.55,0,0,1,6.36,1.6,11.72,11.72,0,0,1,4.39,4.34,12.21,12.21,0,0,1,1.6,6.27,12,12,0,0,1-1.62,6.19,11.81,11.81,0,0,1-4.42,4.37A12.41,12.41,0,0,1,253.71,134Zm0-5.58a5.69,5.69,0,0,0,4.37-1.85,7.43,7.43,0,0,0,0-9.51,6.09,6.09,0,0,0-8.74,0,7.47,7.47,0,0,0,0,9.51A5.72,5.72,0,0,0,253.71,128.37Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M276.36,133.23l-8.87-22.93h6.89l5.32,16.89,5.54-16.89h6.44l-8.83,22.93Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M303.86,134a9.72,9.72,0,0,1-5.43-1.55,10.66,10.66,0,0,1-3.71-4.31,14,14,0,0,1-1.35-6.26,13.34,13.34,0,0,1,1.44-6.24,11.46,11.46,0,0,1,3.9-4.39,9.76,9.76,0,0,1,5.51-1.62,8.73,8.73,0,0,1,4.35,1.1,8,8,0,0,1,3.09,3.13l.09-3.51h5.95v22.93h-5.95l-.09-3.51Q309.27,134,303.86,134Zm1.85-5.58a5.7,5.7,0,0,0,4.37-1.85,7.47,7.47,0,0,0,0-9.51,6.09,6.09,0,0,0-8.74,0,7.47,7.47,0,0,0,0,9.51A5.7,5.7,0,0,0,305.71,128.37Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M334.75,134q-4.1,0-6.12-2.18t-2-6.69v-9.69h-4.46V110.3h4.46v-6.22h6.22v6.22H340v5.09h-7.16v8.51a5.7,5.7,0,0,0,.83,3.5,3.34,3.34,0,0,0,2.77,1.06,7.51,7.51,0,0,0,2.05-.28,13.08,13.08,0,0,0,2-.72l.67,5.14a9.28,9.28,0,0,1-2.84,1A17.49,17.49,0,0,1,334.75,134Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M346.58,133.23V110.3h6.22v22.93Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 349.69,
    cy: 103.57,
    rx: 3.69,
    ry: 3.63
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M369.76,134a12.64,12.64,0,0,1-6.36-1.58A11.58,11.58,0,0,1,359,128a12.33,12.33,0,0,1-1.6-6.24,12.09,12.09,0,0,1,1.62-6.24,11.88,11.88,0,0,1,4.42-4.37,13.32,13.32,0,0,1,12.66,0,11.65,11.65,0,0,1,4.39,4.34,12.21,12.21,0,0,1,1.6,6.27,12,12,0,0,1-1.62,6.19,11.74,11.74,0,0,1-4.42,4.37A12.4,12.4,0,0,1,369.76,134Zm0-5.58a5.72,5.72,0,0,0,4.37-1.85,7.47,7.47,0,0,0,0-9.51,6.09,6.09,0,0,0-8.74,0,7.43,7.43,0,0,0,0,9.51A5.69,5.69,0,0,0,369.76,128.37Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M385.23,133.23V110.3h6l.09,3.33a6.53,6.53,0,0,1,2.77-3,8.55,8.55,0,0,1,4.31-1.06,7.44,7.44,0,0,1,6.06,2.52c1.39,1.68,2.09,4.09,2.09,7.21v13.92h-6.22V120.48q0-5.36-4.14-5.36a4.33,4.33,0,0,0-3.52,1.51,6.44,6.44,0,0,0-1.26,4.26v12.34Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M346.58,41.68V18.75h6.22V41.68Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 349.69,
    cy: 11.81,
    rx: 3.69,
    ry: 3.63
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M232.82,88.7V65.76H239V88.7Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 235.93,
    cy: 58.82,
    rx: 3.69,
    ry: 3.63
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M290,62.45a3.58,3.58,0,0,1-2.63-1.06,3.52,3.52,0,0,1-1.06-2.59,3.41,3.41,0,0,1,1.06-2.59,3.63,3.63,0,0,1,2.63-1,3.67,3.67,0,0,1,2.64,1,3.44,3.44,0,0,1,1.05,2.59,3.55,3.55,0,0,1-1.05,2.59A3.62,3.62,0,0,1,290,62.45ZM286.88,88.7V65.76h6.22V88.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0a19748501a38055d54055b3b6726a2a.svg";
export { ForwardRef as ReactComponent };